export default "mutation insertStoricoUpload($rowUploadHistory: RowUploadHistory!) {\n        insertStoricoUpload(rowUploadHistory: $rowUploadHistory)\n}";